import fathersDayGuid from "@assets/images/GUIDScreens/fathers-day-guid.avif";
import type { GUIDScreenProps } from "./types";

function FathersDay({ line1, line2 }: GUIDScreenProps) {
  return (
    <svg viewBox="0 0 800 340" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#fathers-day-guid-clip)">
        <image
          href={fathersDayGuid.src}
          width="800"
          height="340"
          preserveAspectRatio="xMidYMid slice"
        />
      </g>
      <text
        x="400"
        y="160"
        style={{ fill: "#FFFFFF" }}
        stroke="#1F2022"
        strokeWidth="1"
        paintOrder="stroke"
        fontSize="61"
        textAnchor="middle"
        fontFamily="'Mori Gothic', Arial"
        fontWeight="600"
      >
        {line1 || ""}
      </text>
      <text
        x="400"
        y="226"
        style={{ fill: "#FFFFFF" }}
        stroke="#1F2022"
        strokeWidth="1"
        paintOrder="stroke"
        fontSize="50"
        textAnchor="middle"
        fontFamily="'Mori Gothic', Arial"
        fontWeight="600"
      >
        {line2 || ""}
      </text>
      <defs>
        <clipPath id="fathers-day-guid-clip">
          <rect width="800" height="340" rx="54" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FathersDay;
